import DanishExporter from './country/danishExportMapping.js';
import NorwegianExporter from './country/norwegianExportMapping.js';
import SwedishExporter from './country/swedishExportMapping.js';
import { COUNTRY_CODES } from '../../../../constants/enums';

const EXPORTERS = {
    [COUNTRY_CODES.DENMARK]: DanishExporter,
    [COUNTRY_CODES.NORWAY]: NorwegianExporter,
    [COUNTRY_CODES.SWEDEN]: SwedishExporter
};

export const createExporter = (countryCode, ...args) => {
    const Exporter = EXPORTERS[countryCode.toLowerCase()];
    return new Exporter(...args);
};